if (typeof __webpack_modules__ !== 'undefined' && typeof document !== 'undefined') {
__webpack_require__.$ARUI = { scriptSource: document.currentScript };
}